module.exports = __webpack_public_path__ + "img/title.00575d45.png";